module.exports = __webpack_public_path__ + "static/media/bills-uploadBulk.e1bc1cf6.svg";